import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { routePaths } from '../../routes/routes-path';
import { useDarkMode } from '../../hooks';
import { IMAGES } from '../../constants/common';

const Logo = () => {
  const { isDarkMode } = useDarkMode();
  const location = useLocation();
  const navigate = useNavigate();

  // Bấm logo: đang ở trang chủ thì NẠP LẠI feed; ở trang khác thì về trang chủ.
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname === routePaths.home) {
      window.location.reload();
    } else {
      navigate(routePaths.home);
    }
  };

  return (
    <Link to={routePaths.home} onClick={handleClick}>
      {isDarkMode ? (
        <img src={IMAGES.LOGO} alt="cab VN" className="w-24 h-14 object-contain" />
      ) : (
        <img src={IMAGES.LOGO_DARK} alt="cab VN" className="w-24 h-14 object-contain" />
      )}
    </Link>
  );
};

export default Logo;
